import React, { FunctionComponent } from 'react';
import { Grid, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';

const styles = {
  mainHeader: {
    margin: '1rem 0 !important',
    padding: '1.5rem 0 !important',
  },
  grid: {
    backgroundColor: '#fff !important',
    padding: '2em !important',
    margin: '1.875rem 0 !important',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
  },
  chartPlaceholder: {
    height: '20rem !important',
  },
  headerPlaceholder: {
    '& .line': {
      backgroundColor: '#f7f8f9 !important',
    },
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  className?: string;
};

const ChartPlaceholder: FunctionComponent<Props> = ({ classes, className }) => (
  <Grid className={classnames(className, classes.grid)}>
    <Grid.Row centered>
      <Grid.Column width={14}>
        <Placeholder fluid className={classes.chartPlaceholder}>
          <Placeholder.Line />
          <Placeholder.Image />
        </Placeholder>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default withStyles(styles)(ChartPlaceholder);
